<template>
  <v-ons-page @show="showPage()" :modifier="strategie.done.length ? '' : 'white'">

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        {{ cultLabel }}
      </div>
    </v-ons-toolbar>

    <app-pull-hook-spinner v-if="isSync"></app-pull-hook-spinner>

    <div class="content">

      <div class="content--perfdetail">
        <div :class="{ 'pie-wrapper': strategie.done.length }">
          <div class="arc" :data-value="arcValue"></div>
          <p class="perfdetail-score" @click="showTonne">
            {{ tonne_vendu.toLocaleString('fr') }} t
            <br />
            <span>
              sur {{ tonne_total !== '' ? tonne_total.toLocaleString('fr') : '__' }} t à vendre
              &nbsp;<v-ons-icon icon="fa-pencil-alt"></v-ons-icon>
            </span>
          </p>
        </div>

      </div>

      <div v-if="strategie.done.length">

        <v-ons-list-title modifier="perflist">
          {{ search.normalized.length ?
            (listVentes.length ? listVentes.length : 'Aucune')
              + (listVentes.length > 1 ? ' ventes trouvées' : ' vente trouvée') :
            'Mes ventes'
          }}
          <span v-if="prix_moyen" class="list-title--perflist__right">
            <span>Prix moyen :</span>
            {{ prix_moyen.toLocaleString('fr') }}&nbsp;€/t
          </span>
        </v-ons-list-title>

        <v-ons-list modifier="noborder perflist">

          <v-ons-list-item>
            <v-ons-search-input ref="inputSearch" placeholder="Recherchez une vente" v-model="search.current" :modifier="$mdModifier"
                                @focus="scrollSearch"></v-ons-search-input>
            <v-ons-icon v-show="search.spin" icon="fa-spinner" spin size="20px" :style="$md ? 'top: 26px' : 'top: 16px'"></v-ons-icon>
          </v-ons-list-item>

          <v-ons-list-item v-if="isRespo">
            <div class="left">
              <v-ons-checkbox input-id="checkboxFilterContrat" modifier="material" :value="true" v-model="isFilterContrat"></v-ons-checkbox>
            </div>
            <label class="center" for="checkboxFilterContrat">
              Afficher les ventes à traiter
            </label>
          </v-ons-list-item>

          <v-ons-list-item v-for="item in listVentes.slice(0, limit.size)" :key="item.index" modifier="perfdetail chevron"
                           @click="showVente(item.index)" tappable>

            <div class="left">
              <span class="list-item__thumbnail" :style="{'background-image': item.icon}" />
            </div>

            <div class="center">
              <span class="list-item__title">
                {{ item.label }}
              </span>
              <span class="list-item__subtitle">
                {{ getDateLabelFromFr(item.vente.date) }}<v-ons-icon
                  v-if="item.vente.negoce && item.vente.etat != 'demande' && ! item.vente.otp_missing"
                  :icon="item.vente.id ? 'check-circle' : 'sync'">
                </v-ons-icon>
                <v-ons-icon v-if="item.vente.etat == 'contrat' && (item.vente.is_signe || item.vente.is_signe_otp)" icon="file-signature"></v-ons-icon>
                <v-ons-icon v-else-if="item.vente.etat == 'contrat'" icon="file-contract"></v-ons-icon>
              </span>
            </div>

            <div class="right">
              <div class="list-item__label">
                <span v-if="item.vente.prix !== ''">
                  {{ parseInt(item.vente.prix) == item.vente.prix ?
                    item.vente.prix.toLocaleString('fr') :
                    item.vente.prix.toLocaleString('fr', { minimumFractionDigits: 2 })
                  }} €/t
                </span>
                <span v-else-if="item.vente.cours !== undefined && item.vente.cours !== ''" class="badge-orange">
                  Cours: {{ item.vente.cours.toLocaleString('fr') }} €/t
                </span>
                <span v-else-if="item.vente.base !== undefined && item.vente.base !== ''" class="badge-orange">
                  Base:
                  {{ item.vente.base >= 0 ? '+' : ''}}{{ item.vente.base.toLocaleString('fr') }} €/t
                </span>
              </div>
              <span v-if="item.notif" class="notification">{{ item.notif }}</span>
            </div>

          </v-ons-list-item>

          <v-ons-list-item v-if="limit.next" modifier="perfbutton">
            <v-ons-button modifier="quiet" @click="limit.size += 25">
              Charger plus de ventes
            </v-ons-button>
          </v-ons-list-item>
          
          <v-ons-list-item modifier="perfbutton">
            <v-ons-button modifier="quiet" @click="negoce.length ? isShowVente = true : newVente()">
              Enregistrer une vente
            </v-ons-button>
          </v-ons-list-item>

        </v-ons-list>

      </div>

      <template v-if="! strategie.done.length">
        <div class="content--perfalert__empty" style="height: calc(100% - 208px);">
          <section>
            <img src="../assets/imgs/icon_euro_bg@2x.png" />
            <h3>Renseignez toutes vos ventes</h3>
            <p>Vous pourrez suivre votre prix moyen et taux d'avancement</p>
          </section>
        </div>

        <v-ons-bottom-toolbar modifier="cta transparent">
          <v-ons-button modifier="large--cta perflarge" @click="negoce.length ? isShowVente = true : newVente()">
            Enregistrer une vente
          </v-ons-button>
        </v-ons-bottom-toolbar>
      </template>

    </div>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfbadge rowfooter'" :visible.sync="isShowTonne">
      <template slot="title">
        <img :src="$getBadgeAsset(this.nbFeuille)">
        <br />
        Tonnes à vendre
      </template>
      <span>
        Définissez vos tonnes à vendre pour visualiser automatiquement votre taux d'avancement.
      </span>
      <template slot="footer">
        <v-ons-alert-dialog-button @click="isShowTonne = false">
          Plus tard
        </v-ons-alert-dialog-button>
        <v-ons-alert-dialog-button modifier="primal" @click="showTonne">
          Définir
        </v-ons-alert-dialog-button>
      </template>
    </v-ons-alert-dialog>

    <v-ons-action-sheet v-if="negoce.length" :modifier="$mdModifier" :visible.sync="isShowVente" cancelable
                        title="Sélectionnez une action">
      <v-ons-action-sheet-button v-for="negoceItem in negoce" :key="negoceItem.id" :modifier="$mdModifier"
                                 @click="showVenteDemande(negoceItem.id)">
        Vendre à {{ negoceItem.label }}
      </v-ons-action-sheet-button>
      <v-ons-action-sheet-button :modifier="$mdModifier" @click="newVente">
        Enregistrer une vente réalisée
      </v-ons-action-sheet-button>
      <v-ons-action-sheet-button v-if="! $md" @click="isShowVente = false">Fermer
      </v-ons-action-sheet-button>
    </v-ons-action-sheet>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from "../store.js";

import AppPullHookSpinner from '../partials/PullHookSpinner.vue';

import AppCultureTonne from './CultureTonne.vue';
import AppVenteFiche from './VenteFiche.vue';
import AppClientSelect from './ClientSelect.vue';
import AppVenteDemande from './VenteDemande.vue';
import AppVenteNegoce from './VenteNegoce.vue';
import AppContratVisu from './ContratVisu.vue';
import AppContratPdf from './ContratPdf.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppPullHookSpinner },
  props: ['pageStack'],
  data() {
    return {
      refCulture: '',
      refDestination: '',
      initInfos: '',
      arcValue: 0,
      limit: {
        size: 25,
        next: false
      },
      search: {
        current: '',
        last: '',
        timer: null,
        normalized: '',
        spin: false
      },
      isFilterContrat: false,
      isShowTonne: null,
      isShowVente: false,
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    clientConnect() {
      return this.state.client;
    },
    isSync() {
      return this.state.isSync;
    },
    nbFeuille() {
      return this.state.onboarding.nbFeuille;
    },
    campagne() {
      return this.user.campagne;
    },
    strategie() {
      return this.user.ventes[this.refCulture][this.refDestination];
    },
    tonne_vendu() {
      var tonne = this.getTonneVendu(this.strategie.done, this.clientConnect.id);
      if(tonne > 1000){
        tonne = Math.round(tonne);
      }
      return tonne;
    },
    prix_moyen() {
      return this.getPrixMoyen(this.listVentes.map(item => { return item.vente })); // listVentes car liste filtrée
    },
    tonne_total() {
      if(this.isTech){
        return this.getTonneTotalClient(this.getClientConnectInfos(this.clientConnect.id, this.strategie));
      } else {
        return this.getTonneTotal(this.user.cultures, this.refCulture, this.refDestination, this.strategie.tonne);
      }
    },
    referentiel() {
      return this.data.referentiel;
    },
    cultLabel() {
      return this.getCultLabel();
    },
    negoce() {
      return this.getNegoceAcces(this.data.negoce.list);
    },
    isTech() {
      return this.negoce[0] && this.negoce[0].is_tech;
    },
    isRespo() {
      return this.negoce[0] && this.negoce[0].respo;
    },
    negoceById() {
      var list = {};
      for (let i = 0; i < this.negoce.length; i++) {
        var negoceItem = this.negoce[i];
        list[negoceItem.id] = negoceItem.id;
        if (negoceItem.respo) {
          for (let j = 0; j < negoceItem.respo.length; j++) {
            list[negoceItem.respo[j]] = negoceItem.id;
          }
        } else if (negoceItem.iso) {
          for (let j = 0; j < negoceItem.iso.length; j++) {
            list[negoceItem.iso[j]] = negoceItem.id;
          }
        }
      }
      return list;
    },
    clients() {
      var clients = {};
      if(this.isTech){
        for (const id in this.data.negoce.clients) {
          var client = this.data.negoce.clients[id];
          clients[id] = {
            societe: client.societe,
            name: client.name,
            erp: client.erp
          };
          if(client.id_user){
            clients[client.id_user] = {
              societe: client.societe,
              name: client.name,
              erp: client.erp
            };
          }
        }
      } else {
        for (let i = 0; i < this.negoce.length; i++) {
          var negoceItem = this.negoce[i];
          for (const id in negoceItem.clients) {
            clients[id] = negoceItem.clients[id];
          }
        }
      }
      return clients;
    },
    notifState() {
      return this.state.notif;
    },
    listVentes() {
      var list = [];
      this.limit.next = false;
      var dateNow = new Date().getTime() / 1000;
      for (let i = this.strategie.done.length - 1; i >= 0; i--) {
        var vente = this.strategie.done[i];
        if(this.isFilterContrat){
          if(vente.etat == 'contrat' || (vente.etat == 'vente' && ! vente.contrat && ! vente.otp_missing)){
            continue;
          }
        }
        if(this.clientConnect.id && vente.client != this.clientConnect.id){
          continue;
        }
        var isTech = vente.negoce && this.isTech;
        var venteLabel = vente.tonne.toLocaleString('fr') + ' t • ';
        var searchLabel = [];
        searchLabel.push(vente.tonne.toLocaleString('fr') + 't');
        if(isTech){
          if(this.clients[vente.client]){
            var client = this.clients[vente.client];
            if(client.societe){
              venteLabel += client.societe;
              searchLabel.push(client.societe);
            } else {
              venteLabel += client.name;
            }
            searchLabel.push(client.name);
            if(client.erp){
              searchLabel.push(client.erp);
            }
          } else {
            venteLabel += 'n.c.';
            searchLabel.push('n.c.');
          }
        } else {
          venteLabel += vente.coop;
          searchLabel.push(vente.coop);
          if(this.clients[vente.client]){
            searchLabel.push(this.clients[vente.client]);
          }
        }
        if(this.search.normalized.length){
          searchLabel.push(this.getDateLabelFromFr(vente.date));
          searchLabel.push(vente.prix.toLocaleString('fr') + '€/t');
          searchLabel.push(vente.id);
          searchLabel = this.normalize(searchLabel.join(' '));
          if(this.search.normalized.filter(value => { return ! searchLabel.includes(value) }).length){
            continue;
          }
        }

        if(list.length >= this.limit.size){
          this.limit.next = true;
          if(this.isTech){
            break;
          }
        }

        var isNotif = (isTech && vente.etat == 'demande')
        || vente.otp_missing
        || (! isTech && vente.etat == 'contrat' && (vente.is_signe === false || vente.is_signe_otp === false)
            && ! (vente.signe_expire && vente.signe_expire < dateNow));
        list.push({
          index: i,
          label: venteLabel,
          icon: vente.etat == 'demande' ?
            'url(' + require('../assets/imgs/icon_wait_bg@2x.png') + ')' :
            this.$getCultAsset(this.refCulture, this.refDestination, 'icon'),
          vente: vente,
          notif: isNotif ? 1 : 0
        });
      }
      if(! this.isTech){
        list.sort(function (a, b) {
          var aDate = a.vente.date.split('/').reverse().join('-');
          var bDate = b.vente.date.split('/').reverse().join('-');
          if (aDate > bDate) {
            return -1;
          } else if (aDate == bDate) {
            if (a.index > b.index) {
              return -1;
            } else {
              return 1;
            }
          } else {
            return 1;
          }
        });
      }
      this.search.spin = false;
      return list;
    },
    notifCount() {
      return this.getCultureNotifCount(this.strategie.done, this.negoce, this.refCulture, this.refDestination, this.notifState);
    }
  },
  watch: {
    listVentes() {
      this.updateNotifCount();
    },
    'search.current'(value) {
      this.limit.size = 25;
      if (this.search.timer !== null) {
        clearTimeout(this.search.timer);
      }
      this.search.last = value;
      this.search.spin = true;
      this.search.timer = setTimeout(() => {
        if(this.search.last == this.search.current){
          this.search.normalized = this.search.current.split(' ').map(value => {
            return this.normalize(value);
          }).filter(value => {
            return value;
          });
        };
      }, 500);
    },
    isFilterContrat() {
      this.limit.size = 25;
    }
  },
  methods: {
    showPage() {
      if(this.tonne_total === '' && ! this.notifCount && ! this.isTech && this.isShowTonne === null){
        this.isShowTonne = true;
      }
      this.arcValue = this.tonne_total !== '' ? Math.min(100, Math.round(100 * this.tonne_vendu / this.tonne_total)) : 0;
    },
    showTonne() {
      this.isShowTonne = false;
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      if(this.isTech){
        if(this.clientConnect.id){
          var clientId = this.clientConnect.id;
          this.pageStack.push({
            extends: AppCultureTonne,
            data() {
              return {
                refCulture: refCulture,
                refDestination: refDestination,
                client: clientId
              }
            },
            onsNavigatorOptions: {
              animation: 'lift'
            }
          });
        } else {
          this.pageStack.push({
            extends: AppClientSelect,
            data() {
              return {
                workflow: 'tonne',
                refCulture: refCulture,
                refDestination: refDestination
              }
            },
            onsNavigatorOptions: {
              animation: 'lift'
            }
          });
        }
      } else {
        this.pageStack.push({
          extends: AppCultureTonne,
          data() {
            return {
              refCulture: refCulture,
              refDestination: refDestination
            }
          },
          onsNavigatorOptions: {
            animation: 'lift'
          }
        });
      }
    },
    showVenteDemande(negoceId) {
      this.isShowVente = false;
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      if(this.isTech){
        if(this.clientConnect.id){
          negoceId = this.clientConnect.negoceId;
          var clientId = this.clientConnect.id;
          this.pageStack.push({
            extends: AppVenteDemande,
            data() {
              return {
                negoceId: negoceId,
                refCulture: refCulture,
                refDestination: refDestination,
                vente: {
                  client: clientId
                }
              }
            }
          });
        } else {
          this.pageStack.push({
            extends: AppClientSelect,
            data() {
              return {
                workflow: 'vente',
                refCulture: refCulture,
                refDestination: refDestination
              }
            }
          });
        }
      } else {
        this.pageStack.push({
          extends: AppVenteDemande,
          data() {
            return {
              negoceId: negoceId,
              refCulture: refCulture,
              refDestination: refDestination
            }
          }
        });
        this.sendTrackEvent('negoce click ' + negoceId + ' liste ' + refCulture + ' ' + refDestination);
      }
    },
    newVente() {
      this.isShowVente = false;
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;

      this.pageStack.push({
        extends: AppVenteFiche,
        data() {
          return {
            refCulture: refCulture,
            refDestination: refDestination
          }
        },
        onsNavigatorOptions: {
          animation: 'lift'
        }
      });
    },
    showVente(indexVente) {
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      var vente = this.strategie.done[indexVente];
      if (vente.negoce) {
        var negoceId = this.negoceById[vente.negoce];
        var venteNegoce = (negoceId && this.isRespo ? negoceId : vente.negoce);
        // contrat à générer
        if (negoceId && this.isRespo // respo
          && (vente.etat == 'contrat' || (vente.etat == 'vente' && ! vente.otp_missing && vente.contrat))) { // legacy vente.contrat not set
          this.pageStack.push({
            extends: AppContratVisu,
            data() {
              return {
                negoceId: negoceId,
                indexVente: indexVente,
                refCulture: refCulture,
                refDestination: refDestination,
                isOTP: (vente.etat == 'contrat' && vente.is_signe_otp === false)
              }
            }
          });
        // contrat à signer
        } else if(negoceId && ! this.isTech // agri
          && vente.etat == 'contrat' && (vente.is_signe === false || vente.is_signe_otp === false)) {
          this.pageStack.push({
            extends: AppContratPdf,
            data() {
              return {
                indexVente: indexVente,
                refCulture: refCulture,
                refDestination: refDestination,
                isSignature: (vente.is_signe === false),
                isOTP: (vente.is_signe_otp === false)
              }
            }
          });
        } else {
          this.pageStack.push({
            extends: AppVenteNegoce,
            data() {
              return {
                negoceId: venteNegoce,
                refCulture: refCulture,
                refDestination: refDestination,
                indexVente: indexVente
              }
            }
          });
        }
      } else {
        this.pageStack.push({
          extends: AppVenteFiche,
          data() {
            return {
              refCulture: refCulture,
              refDestination: refDestination,
              indexVente: indexVente
            }
          }
        });
      }
    },
    async updateNotifCount() {
      if (this.notifCount) {
        for (let i = 0; i < this.strategie.done.length; i++) {
          var vente = this.strategie.done[i];
          if (vente.negoce && vente.etat != 'demande') {
            if (!this.notifState[this.refCulture]) {
              this.$set(store.state.notif, this.refCulture, {});
            }
            if (!this.notifState[this.refCulture][this.refDestination]) {
              this.$set(store.state.notif[this.refCulture], this.refDestination, []);
            }
            if (!this.notifState[this.refCulture][this.refDestination].includes(vente.id)) {
              store.state.notif[this.refCulture][this.refDestination].push(vente.id);
            }
          }
        }
        var notifStateStorage = await this.ionicStorage.get('notif_state');
        notifStateStorage[this.campagne] = this.notifState;
        this.ionicStorage.set('notif_state', notifStateStorage);
      }
    },
    scrollSearch() {
      if (this.$ons.platform.isWebView()){
        this.$el.scrollTop = this.$el.querySelector('ons-list-title').offsetTop;
      }
    },
  },
  created() {
    this.updateNotifCount();
    if(this.initInfos == 't'){
      this.showTonne();
    } else if(this.initInfos){
      for (let i = 0; i < this.listVentes.length; i++) {
        var item = this.listVentes[i];
        if(item.vente.id == this.initInfos){
          this.isShowTonne = false;
          this.showVente(item.index);
          break;
        }
      }
    }
  }
}
</script>

<style>
.list-item--perfdetail__right .list-item__expand-chevron {
  margin-left: 9px;
}
.list-item--perfdetail .list-item__expandable-content {
  padding-bottom: 0;
}
.list-item--perfdetail__subtitle .ons-icon {
  margin-left: 4px;
  color: var(--perfarmer-jaune);
}
.perfdetail-score .ons-icon.fa-pencil-alt {
  color: var(--perfarmer-vert);
}
.list--perflist ons-search-input + ons-icon.fa-spinner {
  position: absolute;
  right: 16px;
}
</style>